import React from "react";
import Category from "src/components/side-menu/sub-elements/Category";
import BackButton from "src/components/side-menu/BackButton";
import HeightAnimation from "src/components/layout/HeightAnimation";
import { 
  useIsAlphabetical, 
  useOpenCategoryId, 
  useSearchQuery, 
} from "./side-menu-store";
import { useIsLargeScreen } from "src/helpers/ScreenSizeContext";
import useMenuStructure from "./side-menu-structure/useMenuStructure";
import { useTranslation } from "gatsby-plugin-react-i18next";

export interface ICategoriesContainerProps {
  pdfByCategoryPath?: string | null
  pdfAzPath?: string | null
}

const CategoriesContainer = ({
  pdfByCategoryPath,
  pdfAzPath,
}: ICategoriesContainerProps) => {
  const { t } = useTranslation()
  const isAlphabetical = useIsAlphabetical()
  const searchQuery = useSearchQuery()
  const menuStructure = useMenuStructure()
  const isLarge = useIsLargeScreen()
  const isAnyItemOpen = useOpenCategoryId() != null

  return (
    <>
      <div>
        <HeightAnimation isOpen={isAnyItemOpen}>
          {searchQuery || isAlphabetical 
            ? <></> 
            : <BackButton className='lg:hidden' />
          }
        </HeightAnimation>
      </div>
      <ul className='pb-24 mt-[0.0625rem]'>
        {!menuStructure.length && <p style={{ color: "#90A4B0", marginLeft: "16px", marginTop: "14px" }}>
            {t('NOT FOUND')}
          </p>
        }
        {menuStructure.map((category) => (
            <Category
              category={category}
              key={category.id}
              hideArrow={!!searchQuery || !isLarge || isAlphabetical}
              pdfByCategoryPath={pdfByCategoryPath}
              pdfAzPath={pdfAzPath}
            />
        ))}
      </ul>
    </>
  );
};

export default CategoriesContainer;
